<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        FRN Search
    </h2>
    <hr />
    <mat-dialog-content class="mat-typography">
        <p class="text-base text-tertiary-900 mb-4">
            Use the search filters below to find your FRN:
        </p>

        <form [formGroup]="form" class="flex flex-col gap-2">
            <div class="grid grid-cols-12">
                <div class="w-full col-span-12 sm:col-span-6 sm:col-start-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Search Type</mat-label>
                        <mat-select formControlName="searchType">
                            @for (
                                option of searchTypeOptions;
                                track option.value
                            ) {
                                <mat-option [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="grid grid-cols-12">
                <div class="w-full col-span-12 sm:col-span-6 sm:col-start-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Search</mat-label>
                        @if (isSearchTypeFrn()) {
                            <input
                                matInput
                                title="Search"
                                [formControl]="form.controls.search"
                                [appRegexInput]="regExPattern.NumericOnly"
                                maxlength="10"
                            />
                        } @else {
                            <input
                                matInput
                                title="Search"
                                [formControl]="form.controls.search"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                            />
                        }
                        @if (isSearchTypeName()) {
                            <mat-hint>
                                Enter 3 or more characters to search.
                            </mat-hint>
                        }
                    </mat-form-field>
                </div>
            </div>

            <div class="grid grid-cols-12">
                <div class="w-full col-span-12 sm:col-span-6 sm:col-start-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Licensee State</mat-label>
                        <mat-select
                            formControlName="licenseeState"
                            appSelectTypeahead
                        >
                            @for (option of stateOptions; track option.value) {
                                <mat-option [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="grid grid-cols-12">
                <div class="w-full col-span-12 sm:col-span-6 sm:col-start-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Licensee City</mat-label>
                        <input
                            matInput
                            formControlName="licenseeCity"
                            title="Licensee City"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                        />
                    </mat-form-field>
                </div>
            </div>

            <div class="grid grid-cols-12">
                <div class="w-full col-span-12 sm:col-span-6 sm:col-start-4">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Licensee ZIP Code</mat-label>
                        <input
                            matInput
                            formControlName="licenseeZipCode"
                            title="Licensee ZIP Code"
                            [imask]="maskOptions.postalCode"
                            [unmask]="true"
                            [pattern]="regExPattern.PostalCode"
                        />
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if (hasSearched) {
            <div class="mt-6 relative">
                <div class="mb-2 flex gap-2">
                    <button
                        name="clear-selection-button"
                        type="button"
                        mat-button
                        mat-raised-button
                        color="primary"
                        class="!rounded-lg"
                        (click)="onClearSelection()"
                        [disabled]="!selectedFrnContact.value"
                    >
                        Clear Selection
                    </button>
                    <button
                        name="reset-search-button"
                        type="button"
                        mat-raised-button
                        color="primary"
                        class="!rounded-lg"
                        (click)="onResetSearch()"
                        [disabled]="isResetDisabled || isLoading"
                    >
                        Reset Search
                    </button>
                </div>
                @if (isLoading) {
                    <div
                        class="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50"
                    >
                        <mat-spinner diameter="50"></mat-spinner>
                    </div>
                }
                <ag-grid-angular
                    [context]="context"
                    [rowData]="rowData"
                    [columnDefs]="columnDefs"
                    [gridOptions]="gridOptions"
                    (gridReady)="onGridReady($event)"
                    class="ag-theme-quartz h-[350px] w-full"
                >
                </ag-grid-angular>
            </div>
        }
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!p-5">
        <button
            type="button"
            mat-stroked-button
            color="primary"
            class="!border-primary-700"
            (click)="onCancel()"
        >
            Cancel
        </button>
        <button
            name="frn-entity-search-button"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSearch()"
            [disabled]="form.invalid || isLoading"
        >
            Search
        </button>
        @if (hasSearched) {
            <button
                name="save-and-return-button"
                type="button"
                mat-raised-button
                color="primary"
                (click)="onSaveAndReturn()"
                [disabled]="!selectedFrnContact.value || isLoading"
            >
                Save & Return
            </button>
        }
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
